import React from 'react';
import { useDispatch } from 'react-redux';

import { Invoke } from '@swf/components/StarsWizard/Flow';
import StarsWizard from '@swf/components/StarsWizard/StarsWizard';
import type { Dispatch } from '@swf/core/store';
import { useHomeGamesWidget } from '@swf/poker';

import { HGOnboarding } from '../../types/common';

import Step1 from './Step1';
import Step2 from './Step2';
import Step3 from './Step3';

const NewUserFlow: React.FC<{ widgetId?: string }> = ({ widgetId }) => {
  const { widgetDispatch } = useHomeGamesWidget(widgetId);
  const { modal } = useDispatch<Dispatch>();

  const handleCoachMarkDismiss = () => {
    widgetDispatch.setLocalStorageItem({
      onboarding: { [HGOnboarding.NewUserFlow]: true }
    });
    modal.close();

    return Promise.resolve();
  };

  return (
    <StarsWizard.Group
      name="NewUserFlow"
      flow={[Step1, Step2, Step3, new Invoke('handleCoachMarkDismiss', Step3, Step3)]}
      services={{ handleCoachMarkDismiss }}
    >
      <Step1 />
      <Step2 />
      <Step3 />
    </StarsWizard.Group>
  );
};

NewUserFlow.displayName = 'NewUserFlow';

export default NewUserFlow;
